import { render, staticRenderFns } from "./gameFilterForRating.vue?vue&type=template&id=e2a494ec&scoped=true&"
import script from "./gameFilterForRating.vue?vue&type=script&lang=js&"
export * from "./gameFilterForRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a494ec",
  null
  
)

export default component.exports